'use client';

import { ActiveAccountAvatar } from '@frameio/primary-nav/components/AccountAvatar';
import { useCurrentPageType } from '@frameio/shared/routing/getPageType';
import { Box } from '@frameio/vapor';

/**
 * Renders the account selection button if the current page is the workspaces page

 */
export function AccountSelectionButton() {
  const pageType = useCurrentPageType();

  const isVisible = pageType === 'workspaces';

  return isVisible ? (
    <Box display="flex" gap={2} style={{ pointerEvents: 'all' }}>
      <ActiveAccountAvatar showHalo={false} size={24} />
    </Box>
  ) : null;
}
